<template>
  <div class="home">
    <template v-if="mode == 1">
      <cdSkinPackage1
        :picUrl='picUrl'
        v-on:paylistener="payGo"
      />
    </template>
    <template v-if="mode == 2">
      <cdSkinPackage2
        :picUrl='picUrl'
        v-on:paylistener="payGo"
      />
    </template>
    <template v-if="mode == 3">
      <cdSkinPackage3
        :picUrl='picUrl'
        v-on:paylistener="payGo"
      />
    </template>
  </div>
</template>

<script>
var md5Code = require("@/utils/md5.js")
import cdSkinPackage1 from '@/components/cdSkinPackage1.vue'
import cdSkinPackage2 from '@/components/cdSkinPackage2.vue'
import cdSkinPackage3 from '@/components/cdSkinPackage3.vue'
import request from "@/utils/request.js"
import Cookies from "js-cookie"
import { checkUserAgent } from '@/utils/checkUserAgent'

export default {
  name: "Home",
  components: {
		cdSkinPackage1,
    cdSkinPackage2,
    cdSkinPackage3
	},
  mixins: [checkUserAgent],
  data() {
    return {
      mode: '',
      activateFlag: '',
      picUrl: "",
      setMeal: [],
      longitude: "",
      latitude: "",
      channelId: "",
      productId: "",
      province: "",
      userAgent: ''
    }
  },
  created() {
    this.init();
  },
  
  methods: {
    // 页面初始化
    init() {
      this.checkUserAgent({
        success: (res) => {
          this.userAgent = res // 环境
          console.log(`环境：${res}，首页`)
          this.mode = this.$route.query.mode || '1' // 模式获取
          const activateFlagList = [0, 1, '0', '1']
          if (!this.$route.query.channelid || (!this.$route.query.activateFlag && this.$route.query.activateFlag != 0)) return this.$toast("链接或二维码异常")
          if (!activateFlagList.includes(this.$route.query.activateFlag)) return this.$toast("链接或二维码异常")
          this.channelId = this.$route.query.channelid // 代理商ID
          this.productId = this.$route.query.productId // 卡片ID
          this.activateFlag = this.$route.query.activateFlag || 0
          //获取产品详情
          this.getProductDetail()
          // 获取图片前缀
          this.picUrlQuery()
          Cookies.set("productId", this.productId);
          Cookies.set("cykskid", this.channelId);
          Cookies.set('mode', this.mode);
          Cookies.set('activateFlag', this.activateFlag)
        }
      })
    },
    // 圖片前綴
    picUrlQuery() {
      const that = this;
      request({
        url: "/tour-product/imge/getUrl",
        method: "post",
      })
        .then(function (res) {
          if (res.data.code != "200") {
            throw res.data.msg;
          }
          if (res.data.code == "200") {
            that.picUrl = res.data.data;
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //获取产品详情
    getProductDetail() {
      const that = this;
      try {
        const appId = 1;
        const key = 1112;
        let data = {
          productId: this.productId,
        };
        // 签名生成
        let sign = "appId=" + appId;
        if (data && Object.keys(data).length > 0) {
          let newKeys = Object.keys(data).sort();
          newKeys.forEach((key) => {
            sign += "&" + key + "=" + data[key];
          });
        }
        sign += key;
        sign = md5Code.md5(sign).toUpperCase();
        data.sign = sign;
        data.appId = appId;
        request({
          url: "/tour-product/sysProduct/queryProductDetail",
          method: "post",
          params: data,
        })
          .then(function (res) {
            if (res.data.code == 200) {
              Cookies.set("productType", res.data.data.type)
            } else {
              that.$toast(res.data.msg);
            }
          })
          .catch(function (err) {
            that.$toast(err);
          });
      } catch (e) {
        console.log(e);
      }
    },
    // 领取卡跳转
    payGo() {
      if (!this.channelId || (!this.activateFlag && this.activateFlag != 0)) {
        return this.$toast("链接或二维码异常");
      }
      const activateFlagList = [0, 1, '0', '1']
      if (!activateFlagList.includes(this.$route.query.activateFlag)) return this.$toast("链接或二维码异常")
      this.$router.push({
        path: `./cardDelivery?channelid=${this.channelId}`
      })
    },
  },
};
</script>
<style scoped>
html,
body,
#app {
  height: 100%;
  margin: 0;
}
.h100 {
  height: 100px;
}
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;
}

.content {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 300px;
  left: 0;
  width: 100%;
  height: calc(100% - 170px);
  overflow-x: hidden;
  overflow-y: scroll;
}

/* 背景图层 */
.banner {
  position: relative;
  width: 100%;
  height: 738px;
  background-image: url("../../assets/home/bannerBg.png");
  background-size: cover;
  overflow: hidden;
}
.banner .logo {
  position: absolute;
  top: 39px;
  left: 40px;
  z-index: 99;
  width: 248px;
  height: 48px;
  background-image: url("../../assets/home/LOGO01.png");
  background-repeat: no-repeat;
  background-size: 248px 48px;
}
.banner .slogan {
  padding-top: 88px;
  text-align: center;
}
.banner .slogan img {
  width: 500px;
}
.banner .card-inner {
  position: absolute;
  bottom: -120px;
  left: 0;
  width: 100%;
}
.banner .card-inner img {
  width: 100%;
}
.banner .card-wrap {
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -270px;
}
.banner .card-wrap .card {
  position: relative;
  width: 540px;
}
.banner .card-wrap .card .card-pic {
  width: 100%;
}
.banner .card-wrap .card .card-icon {
  width: 180px;
  position: absolute;
  left: -90px;
  top: -110px;
}
.setMeal {
  display: flex;
  justify-content: space-between;
  margin-top: -50px;
  padding: 0 30px;
  z-index: 99;
}
.setMeal .list {
  position: relative;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  width: calc(50% - 10px);
  background: #fff;
  overflow: hidden;
}
.setMeal .list .title {
  padding: 28px 20px 0 20px;
  width: calc(100% - 40px);
  font-size: 30px;
  font-weight: bold;
  color: #393833;
}
.setMeal .list .subTitle {
  padding: 7px 20px 20px 20px;
  width: calc(100% - 40px);
  font-size: 24px;
  color: #b68508;
}
.setMeal .list .Meal-price {
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
  background-size: cover;
}
.setMeal .list .Meal-price .type {
  height: 112px;
  line-height: 112px;
  font-size: 28px;
  color: #393833;
}
.setMeal .list .Meal-price .price {
  height: 112px;
  line-height: 112px;
  font-size: 38px;
  color: #393833;
  font-weight: bold;
}
/* 工具栏 */
.service-list {
  padding: 0 32px;
}
.service-list .title {
  padding: 32px 0;
  font-size: 32px;
  font-weight: bold;
}
.tool {
  display: flex;
  justify-content: space-between;
  margin-bottom: 54px;
  padding: 0 30px;
  width: calc(100% - 60px);
}
.tool .list {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 28px;
}
.tool .list .pic {
  position: relative;
  width: 96px;
  height: 96px;
  margin-bottom: 20px;
}
.tool .list .pic .title {
  width: 100%;
  height: 100%;
}
.tool .list .pic .icon {
  position: absolute;
  top: 5px;
  right: -15px;
  width: 70px;
  height: 30px;
}

/* 热门景区一 */
.hotScenic {
  border-top: 20px solid #f7f7f7;
}
.hotScenic .hotTitle {
  padding: 60px 32px 16px;
  background-size: 400px 60px;
}
.hotScenic .hotTitle .txt {
  width: 100%;
  font-size: 32px;
  font-weight: bold;
}
.hotScenic .hotContent {
  padding-bottom: 30px;
}
.scenicTop {
  display: flex;
  justify-content: space-between;
  padding: 0px 30px 0 30px;
  width: calc(100% - 60px);
  height: 420px;
  font-size: 24px;
  color: #fff;
}
.scenicTop .first,
.scenicTop .sceond-thire {
  border-radius: 10px;
  width: calc(50% - 10px);
  height: 420px;
}
.scenicTop .sceond-thire {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.scenicTop .first,
.scenicTop .sceond,
.scenicTop .thire {
  position: relative;
}
.scenicTop .sceond,
.scenicTop .thire {
  width: 100%;
  height: 200px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0));
  border-radius: 10px;
}
.scenicTop .pic {
  position: relative;
  border-radius: 10px;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
.tag {
  position: absolute;
  left: 0;
  top: 30px;
  background-color: #ffda4d;
  color: #333;
  padding: 0 20px 0 20px;
  height: 36px;
  line-height: 36px;
}
.tag span {
  position: relative;
  display: block;
}
.tag span:after {
  content: "";
  display: block;
  position: absolute;
  right: -32px;
  top: 0px;
  border-right: 12px solid transparent;
  border-top: 18px solid #ffda4d;
  width: 0;
  height: 0;
}
.tag span:after {
  content: "";
  display: block;
  position: absolute;
  right: -32px;
  bottom: 0px;
  border-left: 12px solid transparent;
  border-bottom: 18px solid #ffda4d;
  width: 0;
  height: 0;
}
.scenicTop .name {
  position: absolute;
  bottom: 64px;
  left: 0;
  padding: 0 10px;
  width: calc(100% - 20px);
  font-size: 32px;
  font-weight: bold;
}
.scenicTop .address-distance {
  display: flex;
  align-items: center;
  position: absolute;
  bottom: 30px;
  left: 0;
  padding: 0 10px;
  width: calc(100% - 20px);
  font-size: 20px;
}
.scenicTop .address-distance .distance {
  padding-left: 20px;
}

/* 热门景区二 */
.scenicList {
  display: flex;
  justify-content: space-between;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  margin: 30px auto 0 auto;
  width: calc(100% - 60px);
  height: 260px;
  font-size: 24px;
  overflow: hidden;
}
.scenicList .pic {
  position: relative;
  flex: 0 0 260px;
  width: 260px;
  height: 260px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}
.scenicList .text {
  display: flex;
  flex-direction: column;
  padding: 0 30px;
  width: calc(100% - 300px);
  height: 260px;
}
.scenicList .name {
  padding-top: 30px;
  font-size: 32px;
  font-weight: bold;
}
.scenicList .address {
  padding-top: 20px;
  height: 90rpx;
  line-height: 45px;
  font-size: 24px;
}
.scenicList .distance {
  padding-top: 20px;
  font-size: 24px;
}
/* logo */
.foot-logo {
  display: block;
  margin: 35px auto;
  width: 280px;
  height: 60px;
}
/* 底部 */
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 100;
  padding: 20px 0 50px 0;
  width: 100%;
  height: 100px;
  background-color: #fff;
}

/* 立即购买 */
.payGo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  width: calc(100% - 60px);
  height: 100px;
  color: #333;
  background-image: url("../../assets/home/payGo.png");
  background-size: 100% 100px;
  background-repeat: no-repeat;
  border-radius: 50px;
  box-shadow: 0px 10px 20px 0px rgba(255, 218, 77, 0.6);
}
.payGo .name-price {
  display: flex;
  flex-direction: column;
  padding-left: 50px;
  height: 100%;
}
.payGo .name-price .name {
  height: 40px;
  font-size: 22px;
  line-height: 40px;
  color: #fff;
}
.payGo .name-price .price {
  height: 60px;
  font-size: 40px;
  line-height: 50px;
  color: #ffc539;
}
.payGo .name-price .icon {
  font-size: 32px;
  color: #ffc539;
}
.payGo .pay {
  display: inline-block;
  padding-right: 50px;
  font-size: 36px;
  font-weight: bold;
}
.nowrap-double {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>
